/* eslint-disable @typescript-eslint/no-unused-vars */

import React, { FC } from "react";

import { HomeStyle } from "./styles";
import { Box } from "@mui/material";
import TemplatePage from "../TemplatePage";
import Page12TokenDCreate from "../../Page12TokenDCreate";
import Headerr from "../../Headerr";

import Page13TokenDReshape from "../../Page13TokenDReshape";

const Update: FC = () => {
  return (
    <TemplatePage>
      <Box sx={HomeStyle.mainContainer}>
        <Page13TokenDReshape passedData={""} />
        <Box>
          <a
            href="https://arpt.com.br/"
            target="_blank"
            rel="noopener noreferrer"
            style={HomeStyle.arptUrl}
          >
            ARPT
          </a>
        </Box>
      </Box>
    </TemplatePage>
    
  );
};

export default Update;
